export default {
  BusinessPurchaseSupplierShop: {
    header: {
      code: '供应商编码',
      name: '供应商名称',
      package: '是否含包装',
      free: '是否包邮',
      commodityCode1: '供应商商品编码',
      sku: '供应商SKU编码',
      commodityCode2: '商品编码',
      skuCode: 'SKU编码'
    },
    export: {
      startData: '开始日期',
      endData: '结束日期',
      excelImport: '导入',
      modify: '修改',
      export: '导出',
      rules: 'Excel导入供应商规则说明',
      p1: '导入时如果存在对应供应商名称，商品编码的供应商商品资料，则覆盖，没有则增加新的记录',
      p2: '导入模板，点击下载',
      title: '供应商商品导入模板',
      productExport: '供应商商品导出',
      p3: '导入Excel格式必须带标题，红色标题为必填；Excel的列请设置为文本格式，不然可能会出现类型转换错误的问题',
      p4: '支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过6万行，如果超过，请分成多次导入。',
      day: '天'
    },

    table: {
      picture: '图片',
      // spuCode: '商品编码',
      // name: '商品名称',
      sku: 'SKU编码',
      skuName: 'SKU名称',
      supplierCode: '供应商编码',
      supplierName: '供应商名称',
      taxUnitPrice: '含税采购价',
      unitPrice: '不含税采购价',
      taxRate: '税率',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码',
      package: '是否含包装',
      shipping: '是否包邮',
      minQty: '最小采购量',
      week: '送货周期',
      remark: '备注',
      updateDate: '修改时间'
    },

    dataForm: {
      title: '供应商信息',
      titleBtn: '操作日志',
      supplier: '供应商',
      week: '送货周期',
      day: '天',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码',
      taxUnitPrice: '含税采购价',
      unitPrice: '不含税采购价',
      taxRate: '税率',
      minQty: '最小采购量',
      package: '是否含包装',
      shipping: '是否包邮',
      remark: '备注',
      productInformation: '关联系统商品信息',
      picture: '产品图片',
      // spuCode: '商品编码',
      // name: '商品名称',
      sku: 'SKU编码',
      skuName: 'SKU名称',
      addCommodity: '添加普通商品',
      edit: '编辑',
      add: '新建',
      supplierId: '请选择供应商',
      taxUnitPriceRule: '请输入含税采购价',
      log: '商品日志',
      msgError: '请选择关联系统商品'
    }
  }
};
